import React from 'react';
import NaraBrand from '../NaraBrand';
import './style.css';

export function PoweredBy() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="nf-product-footer">
      <NaraBrand symbolOnly size={16} />
      <span>&copy; {currentYear} Nara</span>
    </footer>
  );
}